import { createContext, useContext } from 'react';
import type { LucideIcon } from 'lucide-react';

export interface ServicesNavLeaf {
  /** Service id (CDN: the umbrella's canonical service id). */
  id: string;
  label: string;
  /** Console deep-link; services without a wired console fall back to the dashboard category filter. */
  route: string;
}

export interface ServicesNavCategory {
  key: string;
  title: string;
  icon: LucideIcon;
  services: ServicesNavLeaf[];
}

/**
 * The sidebar's tree of provisioned services. The shell does not build it: the composition root
 * does (`src/app/ServicesNavProvider.tsx`, from the module descriptors) and provides it above
 * `AppLayout`, so a shared layer reads the tree without importing a page.
 */
export const ServicesNavContext = createContext<ServicesNavCategory[]>([]);

export function useServicesNavTree(): ServicesNavCategory[] {
  return useContext(ServicesNavContext);
}
